import { render, staticRenderFns } from "./knowledge_details.vue?vue&type=template&id=ce238ff4&scoped=true"
import script from "./knowledge_details.vue?vue&type=script&lang=js"
export * from "./knowledge_details.vue?vue&type=script&lang=js"
import style0 from "./knowledge_details.vue?vue&type=style&index=0&id=ce238ff4&lang=scss&scoped=true"
import style1 from "./knowledge_details.vue?vue&type=style&index=1&id=ce238ff4&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce238ff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce238ff4')) {
      api.createRecord('ce238ff4', component.options)
    } else {
      api.reload('ce238ff4', component.options)
    }
    module.hot.accept("./knowledge_details.vue?vue&type=template&id=ce238ff4&scoped=true", function () {
      api.rerender('ce238ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/knowledge_details.vue"
export default component.exports